const TeaMirabell=[
    {
        id:1,
        title:"малина 0,450л",
        price:"70 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:2,
        title:"смородина 0,450л",
        price:"70 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:3,
        title:"чорниця - малина 0,450л",
        price:"70 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:4,
        title:"обліпиха 0,450л",
        price:"70 грн",
        src: require('../img/tea.webp'),
        text:"",
    }
    
]

export default TeaMirabell;